/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M268.209 452.022c-3.653 2.634-7.938 3.978-12.223 3.978-4.257 0-8.57-1.344-12.222-3.978C234.123 445.026 7 278.494 7 146.64 7 54.871 75.008 0 140.736 0c39.47 0 85.943 20.412 115.25 73.965C285.293 20.412 331.767 0 371.236 0 436.966 0 505 54.87 505 146.641c0 131.853-227.15 298.385-236.791 305.38z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconHeart = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconHeart.defaultProps = {
  theme,
};
IconHeart.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconHeart.displayName = 'IconHeart';
export { IconHeart };
